/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSquareAliases} from '../api'

 export const useQueryGetSquareAliases = createReactQueryHook('getSquareAliases', getSquareAliases)
